import { render, staticRenderFns } from "./RsaFatturazioneDettaglioListComponent.vue?vue&type=template&id=2a5d81da"
import script from "./RsaFatturazioneDettaglioListComponent.vue?vue&type=script&lang=js"
export * from "./RsaFatturazioneDettaglioListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports